import { routes } from "@/constants/routes";
import { Redirect } from "expo-router";

/** Pflegeort-Details gibt es nicht mehr. Pflegestellen liegen unter Meine Pflegestellen. */
export default function LocationDetailRedirect() {
  return <Redirect href={routes.myCareSites} />;
}
